export const createAction =
  (type: string) =>
    (payload = null) => ({
      type,
      payload,
    });

export default createAction;
